import React from 'react';
import { CSSObject } from 'styled-components';
import SvgIcon from '../SvgIcon';
import { Size } from '../SvgIcon/types';
import Box from '../Box';

import { ListItemStyled } from './listItem.styled';

interface ListItemProps {
  icon?: React.ReactNode;
  dataTestId?: string;
  iconSize?: keyof typeof Size;
  alignItems?: string;
  bold?: boolean;
  endItem?: React.ReactNode;
  children?: React.ReactNode | React.ReactNode[];
  sx?: CSSObject;
  style?: React.CSSProperties;
}
// TODO: Alex create separate component ListItemText - for text styling
const ListItem = ({
  icon,
  iconSize,
  bold,
  endItem,
  children,
  dataTestId,
  alignItems = 'center',
  sx,
  style,
}: ListItemProps) => {
  return (
    <ListItemStyled bold={bold} alignItems={alignItems} sx={sx} style={style}>
      {icon ? (
        <Box mr={iconSize === Size.medium ? 2 : 1} sx={{ display: 'flex' }}>
          <SvgIcon icon={icon} size={iconSize} />
        </Box>
      ) : null}
      {children}
      {endItem ? (
        <Box data-testid={dataTestId} sx={{ position: 'absolute', right: 0 }}>
          {endItem}
        </Box>
      ) : null}
    </ListItemStyled>
  );
};

export default ListItem;
